import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getTickets } from 'lib/firebase';
import { Ticket } from 'types/User/firebaseTypes/ticket';

export interface PlanningState {
    deliveries: Array<Ticket>;
    statusFilters: {
        backlog: boolean;
        in_progress: boolean;
        done: boolean;
        archived: boolean;
    };
}

const initialState: PlanningState = {
    deliveries: [],
    statusFilters: {
        backlog: true,
        in_progress: true,
        done: true,
        archived: false,
    },
};

export const getDeliveryTickets = createAsyncThunk(
    'planning/getDeliveryTickets',
    getTickets
);

export const planningSlice = createSlice({
    name: 'planning',
    initialState,
    reducers: {
        setDeliveryTickets: (
            state: PlanningState,
            action: PayloadAction<Array<Ticket>>
        ) => {
            state.deliveries = action.payload;
        },
        clearDeliveryTickets: (state: PlanningState) => {
            state.deliveries = [];
        },
        pushDeliveryTicket: (
            state: PlanningState,
            action: PayloadAction<Ticket>
        ) => {
            state.deliveries = [action.payload, ...state.deliveries];
        },
    },
});

export const { setDeliveryTickets, clearDeliveryTickets, pushDeliveryTicket } =
    planningSlice.actions;

export default planningSlice.reducer;
